import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { ClickOutsideModule } from 'ng-click-outside';

import { CommonBasicModule } from '../Common/Basic/basic.module';
import { ChartsModule } from '../Common/Charts/charts.module';
import { CommonDialogsModule } from '../Common/Dialogs/common-dialogs.module';
import { FilterModule } from '../Common/Filter/filter.module';
import { CommonFormsModule } from '../Common/Forms/forms.module';
import { LayoutModule } from '../Common/Layout/layout.module';
import { MiscModule } from '../Common/Misc/misc.module';
import { TakeOverModule } from '../Common/TakeOver/take-over.module';
import { CoreDialogsModule } from '../Core/Dialogs/dialogs.module';
import { LocalizationModule } from '../Core/Localization/localization.module';
import { MonitorSharedModule } from '../Monitor/Shared/monitoring-shared.module';
import { MentionsModule } from '../Common/Mentions/mentions.module';
import { RhpContextsModule } from '../Common/RhpContexts/rhp-contexts.module';
import { TargetingSharedModule } from '../Common/TargetingShared/targeting-shared.module';
import { RSSFeedService } from '../Monitor/Shared/services/rss-feed.service';
import { AutomationAgentsRoutingModule } from './AutomationAgentsRouter/automation-agents-routing.module';
import { AutomationAgentsComponent } from './Core/components/AutomationAgents/automation-agents.component';
import { AdHocCurationReportComponent } from './components/AdHocCurationReport/ad-hoc-curation-report.component';
import { AdHocAgentManagementPanelComponent } from './components/AdHocAgentManagementPanel/ad-hoc-agent-management-panel.component';
import { AdHocReportPanelComponent } from './components/AdHocReportPanel/ad-hoc-report-panel.component';
import { ManageSourceAgentsPanelComponent } from './components/ManageSourceAgentsPanel/manage-source-agents-panel.component';
import { AgentComponent } from './components/Agent/agent.component';
import { AgentAnalyticsComponent } from './components/AgentAnalytics/agent-analytics.component';
import { AgentCardComponent } from './components/AgentCard/agent-card.component';
import { AgentDashboardComponent } from './components/AgentDashboard/agent-dashboard.component';
import { AgentMentionsComponent } from './components/AgentMentions/agent-mentions.component';
import { AgentSidebarComponent } from './components/AgentSidebar/agent-sidebar.component';
import { AgentSummaryComponent } from './components/AgentSummary/agent-summary.component';
import { AgentManagementComponent } from './components/AgentManagement/agent-management.component';
import { AgentUsageDashboardComponent } from './components/AgentUsageDashboard/agent-usage-dashboard.component';
import { AgentUsageDialogComponent } from './components/AgentUsageDialog/agent-usage-dialog.component';
import { CurationAgentActionsComponent } from './components/CurationAgentActions/curation-agent-actions.component';
import { CurationAgentPanelComponent } from './components/CurationAgentPanel/curation-agent-panel.component';
import { AgentSourcePanelComponent } from './components/AgentSourcePanel/agent-source-panel.component';
import { CurationAgentSourceRowComponent } from './components/CurationAgentSourceRow/curation-agent-source-row.component';
import { AgentUsageService } from './services/agent-usage.service';
import { CurationAgentsService } from './services/curation-agents.service';
import { ActionChipComponent } from './components/ActionChip/action-chip.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        ButtonModule,
        TooltipModule,
        ClickOutsideModule,
        LocalizationModule,
        MiscModule,
        CommonBasicModule,
        ChartsModule,
        CommonFormsModule,
        CommonDialogsModule,
        FilterModule,
        LayoutModule,
        CoreDialogsModule,
        TakeOverModule,
        MonitorSharedModule,
        MentionsModule,
        RhpContextsModule,
        TargetingSharedModule,
        AutomationAgentsRoutingModule
    ],
    declarations: [
        AutomationAgentsComponent,
        AgentManagementComponent,
        AgentCardComponent,
        AgentComponent,
        AgentSidebarComponent,
        AgentSummaryComponent,
        AgentDashboardComponent,
        AgentMentionsComponent,
        AgentAnalyticsComponent,
        AgentUsageDashboardComponent,
        AgentUsageDialogComponent,
        CurationAgentPanelComponent,
        AgentSourcePanelComponent,
        AdHocReportPanelComponent,
        AdHocAgentManagementPanelComponent,
        ManageSourceAgentsPanelComponent,
        AdHocCurationReportComponent,
        CurationAgentSourceRowComponent,
        CurationAgentActionsComponent,
        ActionChipComponent
    ],
    exports: [
        AutomationAgentsComponent,
        ManageSourceAgentsPanelComponent,
        AgentManagementComponent,
        CurationAgentPanelComponent
    ],
    providers: [
        AgentUsageService,
        CurationAgentsService,
        RSSFeedService
    ]
})
export class AutomationAgentsModule {}
